import { useEffect } from "react";
import { gamePhaseAtom } from "./GlobalState.jsx";
import { useAtomValue } from "jotai";
import { getSocket } from "./socket.js";

const socket = getSocket();
import { useParams } from "wouter";
import Game from "./Game.jsx";
import LobbyNew from "./LobbyNew.jsx";
import StarsPatterns2Shader from "./shader/starsPatterns2/StarsPatterns2Shader.jsx";
import GameRulebook from "./components/GameRulebook.jsx";
import { SocketManager } from "./SocketManager.jsx";

export default function Experience() {

  const gamePhase = useAtomValue(gamePhaseAtom)
  const params = useParams()

  useEffect(() => {
    const joinRoom = () => {
      console.log('Joining room:', params.id)
      socket.emit('addUser', { roomId: params.id.toUpperCase(), savedClient: localStorage.getItem('yootGame') }, (response) => {
        if (response === 'success') {
          socket.emit('joinRoom', { roomId: params.id.toUpperCase() })
        }
      })
    }

    if (socket.connected) {
      joinRoom()
    }

    socket.on('connect', joinRoom)
    socket.on('reconnect', joinRoom)

    return () => {
      socket.off('connect', joinRoom)
      socket.off('reconnect', joinRoom)
    }
  }, [params.id])

  return <>
    {/* SocketManager should always be mounted for reconnection to work in all phases */}
    <SocketManager />
    { (gamePhase === 'lobby') && <LobbyNew/> }
    { (gamePhase === 'pregame' || gamePhase === 'game' || gamePhase === 'minigame' || gamePhase === 'finished') && <>
      <Game/>
      { (gamePhase === 'pregame' || gamePhase === 'game') && <GameRulebook/> }
    </> }
    <StarsPatterns2Shader count={10000} texturePath={'/textures/particles/3.png'}/>
    <StarsPatterns2Shader count={10000} texturePath={'/textures/particles/6.png'} size={2}/>
  </>
}